import CheckmarkIcon from './CheckmarkIcon.svg';
import LogoIcon from './ClearbitIcon.svg';
import ClearIcon from './ClearIcon.svg';
import EmptySearchIcon from './EmptySearchIcon.svg';
import EmptyWarningIcon from './EmptyWarningIcon.svg';
import HubspotIcon from './HubspotIcon.svg';
import PageViewIcon from './PageviewIcon.svg';
import PlusIcon from './PlusIcon.svg';
import RemoveIcon from './RemoveIcon.svg';
import SalesforceIcon from './SalesforceIcon.svg';
import SearchIcon from './SearchIcon.svg';
import TraitIcon from './TraitIcon.svg';

export {
  CheckmarkIcon,
  ClearIcon,
  EmptySearchIcon,
  EmptyWarningIcon,
  LogoIcon,
  PageViewIcon,
  PlusIcon,
  RemoveIcon,
  SalesforceIcon,
  HubspotIcon,
  SearchIcon,
  TraitIcon,
};
